<template>
  <div>
    <h4>Аккаунт</h4>
    <ul class="text-muted mt-12 stack-sm">
      <li>Тариф: {{ accData.plan.name }} до {{ formatDate(accData.plan.expireDate) }}</li>
      <li>Ежемесячный платеж: {{ formatNumber(accData.monthlyPayment, 'currency') }}</li>
      <li>Текущий баланс: {{ formatNumber(accData.balance, 'currency') }}</li>
      <li>Количество пользователей: {{ accData.usersCount }}</li>
      <li>
        <div class="flex-inline-center">
          Свободно:
          {{ formatNumber(accData.storageEmpty, 'storage') }} из
          {{ formatNumber(accData.storageTotal, 'storage') }}&nbsp;
          <el-tooltip placement="top-start">
            <div slot="content" class="w-250">В объем общего дискового пространства также входит объем занятый под ваши рабочие файлы и настройки рабочего стола</div>
            <span class="icon icon-rg cursor-pointer" v-html="require('@/assets/img/icons/question-mark.svg')" />
          </el-tooltip>
        </div>
        <div class="mt-12">
          <el-progress :percentage="storagePercent" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { formatNumber } from '@/utils'
  import { formatDate } from '@/utils'

  export default {
    computed: {
      accData() {
        return this.$store.state.user.accInfo || {}
      },
      storagePercent() {
        const { storageEmpty, storageTotal: total } = this.$store.state.user.accInfo
        const occupied = total - storageEmpty
        const percent = Math.round(occupied / total * 100)

        if (percent > 100) return 100
        if (percent < 0) return 0
        return percent || 0
      }
    },

    methods: {
      formatNumber,
      formatDate
    }
  }
</script>

<style lang="scss" scoped>
  .w-250 {
    width: 250px;
  }
</style>
